import { policyDetailsFromSegments } from '@ourbranch/policy-utils';

// Select the segment that produced this request, including inherited car/driver details from earlier
// segments. Using today's cars for a historical request could label the wrong vehicle.
export const getSegmentDetailsForCdRequest = (policy, requestId) => {
  const segment = policy?.segments
    ?.slice()
    .reverse()
    .find((item) => item.clarionDoorId === requestId);
  if (!requestId || !segment) {
    return {};
  }
  return policyDetailsFromSegments(policy, { upToSegmentId: segment.segmentId, ignoreRenewalSegments: false }) ?? {};
};
